export const servicios = {
    text1: "Liste der Serviceanfragen",
    text2: "Anfragen Ihrer Kunden",
    text3: "Anfragenliste",
    text4: "Alle",
    text5: "Ausstehend",
    text6: "Genehmigt",
    text7: "Abgelehnt",
    text8: "Bezahlt",
    text9: "Service",
    text10: "Kunde",
    text11: "Telefon",
    text12: "Erstellt",
    text13: "Status",
    text14: "Bestellung ansehen",
    text15: "Serviceanfrage.",
    text16: "Anfragedaten",
    text17: "Anfragedatum:",
    text18: " um",
    text19: "Serviceinformationen",
    text20: "Preis:",
    text21: "Preis pro:",
    text22: "Kategorie:",
    text23: "Anbieter:",
    text24: "Anbieter:",
    text25: "Interner Service",
    text26: "Serviceinformationen",
    text27: "Service nicht gefunden",
    text28: "Angaben zum Antragsteller",
    text29: "Telefon:",
    text30: "E-Mail:",
    text31: "Dokumentart:",
    text32: "Dokumentnummer:",
    text33: "Schließen",
    text34: "Ablehnen",
    text35: "Genehmigen",
    text36: "Zahlung bestätigen",
    text37: "Anfrage ablehnen",
    text38: "Anfrage genehmigen",
    text39: "Zahlung des Antragstellers bestätigen",
    text40: "Möchten Sie die Serviceanfrage wirklich ablehnen?",
    text41: "Kontaktieren Sie den Antragsteller, bevor Sie die Anfrage genehmigen",
    text42: "Mit der Bestätigung der Zahlung des Antragstellers ist der Vorgang abgeschlossen",
    text43: "Ablehnen",
    text44: "Anfrage genehmigen",
    text45: "Ich habe die Zahlung bereits bestätigt",
    text46: "Abbrechen",
    text47: "Erfolgreich aktualisiert.",

    // New labels  

    p1: `Heute`,
    p2: `Angefragter Service`,
    p3: `Gast`,
    p4: `Anfragedatum`,
    p5: `Es liegen noch keine Serviceanfragen vor`,
    p6: `Sie haben noch keine Services eingerichtet.`,
    p7: `Richten Sie die Services Ihrer Unterkunft ein, damit Ihre Gäste Anfragen stellen können`,
    p8: `Service einrichten`,
    p9: `Beratung`,
    p10: `Serviceanfrage verwerfen`,
    p11: `Sind Sie sicher? Die Daten der Anfrage gehen verloren`,
    p12: `Verwerfen`,
    p13: `Serviceanfrage erfolgreich gelöscht`,
    p14: "Laden Sie bis zu 3 Fotos Ihres Service hoch",
    p15: "Fotos zum Hochladen hierher ziehen",
    p16: "...oder klicken, um Fotos von Ihrem Computer auszuwählen",
    p17: "Klicken, um ein Bild aus Ihrer Galerie auszuwählen"
};
